import useBrowserStorage from "./useBrowserStorage";
import { CURRENT_GAME_KEY } from "../utils/constants";

export default function () {
  const { getItem, setItem, removeItem } = useBrowserStorage();
  const getCurrentGame = () => {
    return getItem(CURRENT_GAME_KEY);
  };
  const isCurrentGameExist = () => {
    const game = getCurrentGame();
    return !!game;
  };
  const setGame = (game) => {
    setItem(CURRENT_GAME_KEY, game);
  };
  const removeCurrentGame = () => {
    removeItem(CURRENT_GAME_KEY);
  };

  const setCurrentMarathonStep = (step) => {
    setItem("currentMarathonStep", step);
  };
  const getCurrentMarathonStep = () => {
    return getItem("currentMarathonStep");
  };
  const removeCurrentMarathonStep = () => {
    removeItem("currentMarathonStep");
  };

  const setMarathonStepsMap = (map) => {
    setItem("marathonStepsMap", map);
  };
  const getMarathonStepsMap = () => {
    return getItem("marathonStepsMap");
  };

  return {
    setGame,
    getCurrentGame,
    isCurrentGameExist,
    removeCurrentGame,
    setCurrentMarathonStep,
    getCurrentMarathonStep,
    removeCurrentMarathonStep,
    setMarathonStepsMap,
    getMarathonStepsMap,
  };
}
